import AssetPlans from './AssetPlans';

export default AssetPlans;
